import { render, staticRenderFns } from "./MarkSheetArchiveSheetRecord.vue?vue&type=template&id=5e4e3460&scoped=true&"
import script from "./MarkSheetArchiveSheetRecord.vue?vue&type=script&lang=js&"
export * from "./MarkSheetArchiveSheetRecord.vue?vue&type=script&lang=js&"
import style0 from "./MarkSheetArchiveSheetRecord.vue?vue&type=style&index=0&id=5e4e3460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e3460",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
